
// import { getField, updateField } from 'vuex-map-fields'
import eLeaveApi from '../../../api/leave/eLeave'
import { ABSENT_TYPE } from '../../../constant/constant'
import { formatDateTime } from '../../../utils/datetimeUtil'

const state = {
  feriasForm: {
    assignedToEuid: null,
    assignedToGroupId: null,
    callbackUrl: null,
    position: null,
    changePlanFrom1: null,
    changePlanFrom2: null,
    changePlanFrom3: null,
    changePlanReason: null,
    changePlanTo1: null,
    changePlanTo2: null,
    changePlanTo3: null,
    claimNoLongFerias: null,
    endDate1: null,
    endDate2: null,
    department: null,
    feriasTypeChangePlan: null,
    feriasTypePlanned: null,
    feriasTypeUseNextYear: null,
    memoLeave: null,
    memoStay: null,
    name: null,
    // formCode: null,
    // id: null,
    numDays1: null,
    numDays2: null,
    approver: null,
    serveLessThan1Year: null,
    serveOver1Year: null,
    startDate1: null,
    startDate2: null
  },
  transferForm: {
    approver: null,
    assignedToEuid: null,
    assignedToGroupId: null,
    callbackUrl: null,
    name: null,
    position: null,
    department: null,
    transferDayPersonal: 0,
    transferDayWorking: 0,
    transferDayWorkingDesc: null
  },
  faltasForm: {
    absentTypeId: null, // ID=13,14 取決於 relationTypeId
    approver: null,
    assignedToEuid: null,
    assignedToGroupId: null,
    callbackUrl: null,
    department: null,
    endDate1: null,
    endDate2: null,
    examSubjectContent: null, // 考試科目  (參加期末考試) - 請指出科目
    examTimeFromHour: null,
    examTimeFromMinute: null,
    examTimeToHour: null,
    examTimeToMinute: null,
    memoLeave: null, // 往外地聯絡電話/地址
    memoStay: null, // 留澳聯絡電話/地址
    name: null,
    numDays1: null,
    numDays2: null,
    obrigacoesLegaisContent: null, // 屐行法定義務 - 請指出
    otherReason: null, // 其他原因（請指出）
    position: null,
    relationshipContent: null, // 用戶選擇關係之 chinDesc / portDesc
    relationshipRemark: null,
    relativeTypeId: null,
    // relativeType: {}, // type object
    startDate1: null,
    startDate2: null,
    attachments: []
  },
  leaveStat: {},
  faltasAbsenceTypes: [],
  customAbsenceTypes: [],
  feriasRecords: [],
  faltasRecords: [],
  compensateStat: [],
  entityConfig: {},
  isEntityConfigReady: false
}

// actions
const actions = {
  // initForm ({ commit, rootState }) {
  //   // g2eApi.getStaff(staff => {
  //   //   commit('setForm', staff)
  //   // })
  //   commit('setFeriasForm', { staff: rootState.staff.info, appraiser: rootState.staff.appraiser })
  // },

  // clearForm ({ commit, rootState }) {
  //   commit('clearForm', { staff: rootState.staff.info, appraiser: rootState.staff.appraiser })
  // },

  assignFeriasForm ({ commit }, form) {
    commit('setFeriasForm', form)
  },

  assignTransferForm ({ commit }, form) {
    commit('setTransferForm', form)
  },

  assignFaltasForm ({ commit }, form) {
    commit('setFaltasForm', form)
  },

  getLeaveStat ({ commit }, year) {
    eLeaveApi.getStaffLeaveStat(year, stat => {
      commit('setLeaveStat', stat)
    })
  },

  getFaltasAbsenceTypes ({ commit }) {
    eLeaveApi.getFaltasAbsenceTypes(types => {
      commit('setFaltasAbsenceTypes', types)
    })
  },

  getFeriasRecords ({ commit }, numOfYear) {
    let year = new Date().getFullYear()
    let startYear = year - numOfYear
    let endYear = year
    eLeaveApi.getStaffFeriasByYear({ 'startYear': startYear, 'endYear': endYear }, records => {
      commit('setFeriasRecords', records)
    })
  },

  getFeriasRecordsThisYear ({ commit }) {
    let year = new Date().getFullYear()
    eLeaveApi.getStaffFeriasByYear({ 'startYear': year, 'endYear': year }, records => {
      commit('setFeriasRecords', records)
    })
  },

  getFaltasRecords ({ commit }, numOfYear) {
    let year = new Date().getFullYear()
    let startYear = year - numOfYear
    let endYear = year
    eLeaveApi.getStaffFaltasByYear({ 'startYear': startYear, 'endYear': endYear }, records => {
      commit('setFaltasRecords', records)
    })
  },

  // getFaltasRecordsThisYear ({ commit }) {
  //   let year = new Date().getFullYear()
  //   eLeaveApi.getStaffFaltasByYear({ 'startYear': year, 'endYear': year }, records => {
  //     commit('setFaltasRecords', records)
  //   })
  // },

  getCompensateStat ({ commit }, year) {
    eLeaveApi.getStaffCompensateHours(year, stat => {
      commit('setCompensateStat', stat)
    })
  },

  getEntityConfig ({ commit }) {
    eLeaveApi.getHrEleaveEntityConfig(resp => {
      commit('setEntityConfig', resp)
      commit('setIsEntityConfigReady', true)
    })
  }

}

const getters = {
  // getField
  countNumDaysOfNextYearLeave: (state) => {
    let totalLeaveDays = 0
    if (state.leaveStat.listApprovedNextYearFeriasDays) {
      state.leaveStat.listApprovedNextYearFeriasDays.forEach(
        function (stat) {
          totalLeaveDays += stat.numDays
        }
      )
    }
    return totalLeaveDays
  }
}

const mutations = {
  // updateField,
//   // Below mutation methods are for special case
//   setCareerId (state, value) {
//     state.info.careerId = value
//   },
//   setCategoryId (state, value) {
//     state.info.categoryId = value
//   },
//   setFirstApproverStaffCode (state, value) {
//     state.info.firstApproverStaffCode = value
//   },
//   setIsDirectToCoordinator (state, value) {
//     state.info.isDirectToCoordinator = value
//   },

  setFeriasForm (state, form) {
    state.feriasForm.assignedToEuid = form.assignedToEuid
    state.feriasForm.assignedToGroupId = form.assignedToGroupId
    state.feriasForm.callbackUrl = form.callbackUrl
    state.feriasForm.position = form.position
    state.feriasForm.changePlanFrom1 = form.changeStartDate1
    state.feriasForm.changePlanFrom2 = form.changeStartDate2
    state.feriasForm.changePlanFrom3 = form.changeStartDate3
    state.feriasForm.changePlanReason = form.changePlanReason
    state.feriasForm.changePlanTo1 = form.changeEndDate1
    state.feriasForm.changePlanTo2 = form.changeEndDate2
    state.feriasForm.changePlanTo3 = form.changeEndDate3
    state.feriasForm.claimNoLongFerias = form.claimNoLongFerias
    state.feriasForm.endDate1 = formatDateTime(form.endDate1)
    state.feriasForm.endDate2 = formatDateTime(form.endDate2)
    state.feriasForm.department = form.department
    state.feriasForm.feriasTypeChangePlan = form.feriasTypeChangePlan
    state.feriasForm.feriasTypePlanned = form.feriasTypePlanned
    state.feriasForm.feriasTypeUnplanned = form.feriasTypeUnplanned
    state.feriasForm.feriasTypeUseNextYear = form.feriasTypeUseNextYear
    state.feriasForm.name = form.name
    state.feriasForm.memoLeave = form.goOutContact
    state.feriasForm.memoStay = form.stayMacauContact
    state.feriasForm.numDays1 = form.days1
    state.feriasForm.numDays2 = form.days2
    state.feriasForm.approver = form.approver
    if (form.feriasTypeUseNextYear) {
      if (form.serveOver1Year === 'true') {
        state.feriasForm.serveLessThan1Year = false
        state.feriasForm.serveOver1Year = true
      } else {
        state.feriasForm.serveLessThan1Year = true
        state.feriasForm.serveOver1Year = false
      }
    } else {
      state.feriasForm.serveLessThan1Year = null
      state.feriasForm.serveOver1Year = null
    }
    state.feriasForm.startDate1 = formatDateTime(form.startDate1)
    state.feriasForm.startDate2 = formatDateTime(form.startDate2)
    // state.feriasForm.jobDescription = this._vm.$chPtObjData('jobAreaChinDesc', form.staff)
  },

  setTransferForm (state, form) {
    state.transferForm = form
  },

  setFaltasForm (state, form) {
    state.faltasForm.absentTypeId = form.absentTypeId
    if (form.relativeType && form.absentTypeId === ABSENT_TYPE.DEAD_FIRST_SECOND_ID) {
      state.faltasForm.absentTypeId = form.relativeType.absentTypeId
      state.faltasForm.relationshipContent = form.relationshipContent
      state.faltasForm.relationshipRemark = form.relationshipRemark
      state.faltasForm.relativeTypeId = form.relativeType.id
    } else {
      state.faltasForm.relationshipContent = null
      state.faltasForm.relationshipRemark = null
      state.faltasForm.relativeTypeId = null
    }
    state.faltasForm.approver = form.approver
    state.faltasForm.assignedToEuid = form.assignedToEuid
    state.faltasForm.assignedToGroupId = form.assignedToGroupId
    state.faltasForm.callbackUrl = form.callbackUrl
    state.faltasForm.department = form.department
    state.faltasForm.startDate1 = formatDateTime(form.startDate1)
    state.faltasForm.endDate1 = formatDateTime(form.endDate1)
    state.faltasForm.examSubjectContent = form.examSubjectContent
    if (form.absentTypeId === ABSENT_TYPE.PUBLIC_EXAM_ID && form.examTimeFrom) {
      let times = form.examTimeFrom.split(':')
      state.faltasForm.examTimeFromHour = times[0]
      state.faltasForm.examTimeFromMinute = times[1]
    }
    if (form.absentTypeId === ABSENT_TYPE.PUBLIC_EXAM_ID && form.examTimeTo) {
      let times = form.examTimeTo.split(':')
      state.faltasForm.examTimeToHour = times[0]
      state.faltasForm.examTimeToMinute = times[1]
    }
    state.faltasForm.name = form.name
    state.faltasForm.numDays1 = form.numDays1 // form.numDays1
    state.faltasForm.obrigacoesLegaisContent = form.obrigacoesLegaisContent
    state.faltasForm.otherReason = form.otherReason
    state.faltasForm.position = form.position
    state.faltasForm.memoLeave = form.memoLeave
    state.faltasForm.memoStay = form.memoStay
    state.faltasForm.attachments = form.attachments

    // if (form.absentTypeId === ABSENT_TYPE.DEAD_FIRST_SECOND_ID) {
    //   if (form.relativeTypeId && form.relativeTypeId < 7) {
    //     state.faltasForm.absentTypeId = ABSENT_TYPE.DEAD_FIRST_SECOND_ID // 一二等親
    //   } else {
    //     state.faltasForm.absentTypeId = ABSENT_TYPE.DEAD_THIRD_ID // 三等親
    //   }
    // }

    // state.feriasForm.jobDescription = this._vm.$chPtObjData('jobAreaChinDesc', form.staff)
  },

  setLeaveStat (state, stat) {
    state.leaveStat = stat
  },

  setFaltasAbsenceTypes (state, types) {
    state.faltasAbsenceTypes = types
    state.customAbsenceTypes = types.filter(type => type.id !== ABSENT_TYPE.DEAD_THIRD_ID)
    let abasenceType = state.customAbsenceTypes.find(type => type.id === ABSENT_TYPE.DEAD_FIRST_SECOND_ID)
    abasenceType.chinDesc = '喪事（請指出與死者關係）'
    abasenceType.portDesc = 'Falecimento de (Indique o grau de parentesco do familiar falecido)'
    abasenceType = state.customAbsenceTypes.find(type => type.id === ABSENT_TYPE.PUBLIC_EXAM_ID)
    abasenceType.chinDesc = '公開考試'
    abasenceType.portDesc = 'Realização de concurso'
    abasenceType = state.customAbsenceTypes.find(type => type.id === ABSENT_TYPE.EXAM_SUBJECT_ID)
    abasenceType.chinDesc = '考試科目'
    abasenceType.portDesc = 'Prova na disciplina de'
  },

  setFeriasRecords (state, records) {
    let tempRecords = records.map(record => {
      return Object.assign(record, {
        period: record.startDate + ' ~ ' + record.endDate,
        appStatus: 'eLeave.appStatus.' + record.appStatusCode
      })
    })
    // tempRecords.sort((a, b) => b.startDate - a.startDate)
    tempRecords.reverse()
    state.feriasRecords = tempRecords
  },

  setFaltasRecords (state, records) {
    let tempRecords = records.map(record => {
      return Object.assign(record, {
        period: record.startDate + ' ~ ' + record.endDate,
        appStatus: 'eLeave.appStatus.' + record.appStatusCode
      })
    })
    // tempRecords.sort((a, b) => b.startDate - a.startDate)
    tempRecords.reverse()
    state.faltasRecords = tempRecords
  },

  setCompensateStat (state, stat) {
    state.compensateStat = stat
  },

  setEntityConfig (state, config) {
    state.entityConfig = config
  },

  setIsEntityConfigReady (state, isLoading) {
    state.isEntityConfigReady = isLoading
  }

//   setChinPortNames (state, payload) {
//     state.info.chinCategoryName = payload.category.chinDesc
//     state.info.portCategoryName = payload.category.portDesc
//     state.info.chinCategoryScaleName = payload.categoryScale.chinDesc
//     state.info.portCategoryScaleName = payload.categoryScale.portDesc
//     state.info.chinSubunitEntityName = payload.subunitEntity.chinName
//     state.info.portSubunitEntityName = payload.subunitEntity.portName
//     state.info.chinVinculumTypeName = payload.vinculumType.chinDesc
//     state.info.portVinculumTypeName = payload.vinculumType.portDesc
//   }
}

// export const { mapFields: mapCourseAppFormFields } = createHelpers({
//   getterType: 'courseAppForm/getField',
//   mutationType: 'courseAppForm/updateField'
// })

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
